import { useSelector, useDispatch } from "react-redux"
import { useMutation, useQuery } from "@tanstack/react-query"
import { Col, Row } from 'antd'
import { 
	CargaMasterSellIn, 
	UploadPricingMasterServices, 
	UploadProductMasterLastServices, 
	UploadProductMasterServices,
	UploadRealSellinServices,
	UploadSellOutServices,
	UploadMasterClientsServices,
	UploadBaselineServices,
	UploadMasterExChangeRateServices,
	UploadForecastServices,
	GetDataForecastServices,
	DownloadTemplatesServices,
	updateNotifications
} from "../../Redux/Services/FileUpload"
import CardFileUpload from '../../Components/FileUpload/CardFileUpload'
import CardNotification from '../../Components/FileUpload/CardNotification'
import './../../Styles/Routes/FileUpload.css'
import { useEffect } from "react"
import { getDataVersionBaselineServices, getDataVersionsFiltersServices, getDataVersionsServices } from "../../Redux/Services/Baseline"

const FileUpload = () => {

	const dispatch = useDispatch()

	const { rex_msgs_notificaciones } = useSelector(state => state.fileUpload)
	const { 
		rex_version_selected_baseline
	} = useSelector(state => state.baseline)

	const { isLoading: isLoadingForecast } = useQuery({
		queryKey: ['forecastServices'],
		queryFn : () => GetDataForecastServices(dispatch),
		retry: 1,
		refetchOnWindowFocus : false,
	})

	const { rex_data_user } = useSelector(state => state.user)

	const uploadPricingMaster = useMutation({
        mutationFn: (fileUrl) => UploadPricingMasterServices(dispatch, rex_msgs_notificaciones,fileUrl),
    })


	//CARGAR ARCHIVO SELL IN
	const uploadRealSellin = useMutation({
		mutationFn: (fileUrl) => UploadRealSellinServices(dispatch, rex_msgs_notificaciones, rex_data_user, fileUrl),
		onError: (error) => {
			updateNotifications(dispatch, error.notification);
			console.log('Error uploading Sell In', error.message);
		},
		onSuccess: (notification) => {
			updateNotifications(dispatch, notification);
			console.log('Sell in uploaded successfully')
		}
	})

	//CARGAR ARCHIVO MAESTRA DE PRODUCTOS
	const uploadProductMaster = useMutation({
		mutationFn: (fileUrl) => UploadProductMasterServices(dispatch, rex_msgs_notificaciones, fileUrl),
		onError: (error) => {
			updateNotifications(dispatch, error.notification);
			console.log('Error uploading maestra de productos', error.message);
		},
		onSuccess: (notification) => {
			updateNotifications(dispatch, notification);
			console.log('Maestra de productos uploaded successfully')
		}
	})

	// const uploadProductMasterLast = useMutation({
	// 	mutationFn: (fileUrl) => UploadProductMasterLastServices(dispatch, rex_msgs_notificaciones, fileUrl)
	// })

	//CARGAR ARCHIVO MAESTRA DE CLIENTES
	const uploadClientMaster = useMutation({
		mutationFn: (fileUrl) => UploadMasterClientsServices(dispatch, rex_msgs_notificaciones, fileUrl),
		onError: (error) => {
			updateNotifications(dispatch, error.notification);
			console.log('Error uploading maestra de clientes', error.message);
		},
		onSuccess: (notification) => {
			updateNotifications(dispatch, notification);
			console.log('Maestra de clientes uploaded successfully')
		}
	})

	//CARGAR ARCHIVO MAESTRA DE TIPO DE CAMBIO
	const uploadExChangeRate = useMutation({
		mutationFn: (fileUrl) => UploadMasterExChangeRateServices(dispatch, rex_msgs_notificaciones, fileUrl),
		onError: (error) => {
			updateNotifications(dispatch, error.notification);
			console.log('Error uploading tipo de cambio', error.message);
		},
		onSuccess: (notification) => {
			updateNotifications(dispatch, notification);
			console.log('Tipo de cambio uploaded successfully');
		}
	})

	const cargaMasterSellIn = useMutation({
        mutationFn: (fileUrl) => CargaMasterSellIn(dispatch, rex_msgs_notificaciones, fileUrl),
	})

	//CARGAR ARCHIVO DE SELL OUT
	const uploadSellOut = useMutation({
		mutationFn: (fileUrl) => UploadSellOutServices(dispatch, rex_msgs_notificaciones, fileUrl, rex_data_user),
		onError: (error) => {
			updateNotifications(dispatch, error.notification);
			console.log('Error uploading Sell Out', error.message);
		},
		onSuccess: (notification) => {
			updateNotifications(dispatch, notification);
			console.log('Sell Out uploaded successfully');
		}
	})

	//CARGAR ARCHIVO DE BASELINE
	const uploadBaseline = useMutation({
		mutationFn: (fileUrl) => UploadBaselineServices(dispatch, rex_msgs_notificaciones, fileUrl, null, rex_version_selected_baseline, rex_data_user),
		onError: (error) => {
			updateNotifications(dispatch, error.notification);
			console.log('Error uploading Baseline', error.message);
		},
		onSuccess: (notification) => {
			updateNotifications(dispatch, notification);
			console.log('Baseline uploaded successfully');
		}
	})

	//CARGAR ARCHIVO DE FORECAST
	const uploadForecast = useMutation({
		mutationFn: ({fileUrl, valueForecast}) => UploadForecastServices(dispatch, rex_msgs_notificaciones, fileUrl, null, valueForecast, rex_data_user),
		onError: (error) => {
			updateNotifications(dispatch, error.notification);
			console.log('Error uploading Forecast', error.message);
		},
		onSuccess: (notification) => {
			updateNotifications(dispatch, notification);
			console.log('Forecast uploaded successfully');
		}
	})

	const downloadTemplates = useMutation({
        mutationFn: (name) => DownloadTemplatesServices(name),
    })

	const { isLoading: isLoadingVersions, data: response_vers } = useQuery({
		queryKey: ['versionsFileUpload'],
		queryFn : () => getDataVersionBaselineServices(dispatch),
		retry: 1,
		refetchOnWindowFocus : false,
	})

	return (
		<Row>
			<Col span={24} style={{ margin: '15px 0' }}>
				<div style={{ fontSize: '20px', fontWeight: 'bold' }}>Carga de Archivos</div>
			</Col>
			<Col span={18}>
				<Row gutter={[30, 30]}>
					<Col span={6} className='ContainerCardFileUpload'>
						<CardFileUpload
							nameFile={"Plantilla baseline"}
							onAction={(fileUrl) => {
								uploadBaseline.mutate(fileUrl)
							}}
							nameFileTemplate="Baseline"
							onDownloadTemplates={(name) => {
								downloadTemplates.mutate(name)
							}}
							isLoading={uploadBaseline.isPending}
							isSuccess={uploadBaseline.isSuccess}
							isError={uploadBaseline.isError}
						/>
					</Col>
					<Col span={6} className='ContainerCardFileUpload'>
						<CardFileUpload
							nameFile={"Plantilla forecast"}
							onAction={(fileUrl, valueForecast) => {
								uploadForecast.mutate({fileUrl, valueForecast})
							}}
							nameFileTemplate="Forecast"
							onDownloadTemplates={(name) => {
								downloadTemplates.mutate(name)
							}}
							isLoading={uploadForecast.isPending}
							isSuccess={uploadForecast.isSuccess}
							isError={uploadForecast.isError}
						/>
					</Col>
					<Col span={6} className='ContainerCardFileUpload'>
						<CardFileUpload
							nameFile={"Plantilla Sell In"}
							onAction={(fileUrl) => {
								uploadRealSellin.mutate(fileUrl)
							}}
							nameFileTemplate="Sell In"
							onDownloadTemplates={(name) => {
								downloadTemplates.mutate(name)
							}}
							isLoading={uploadRealSellin.isPending}
							isSuccess={uploadRealSellin.isSuccess}
							isError={uploadRealSellin.isError}
						/>
					</Col>
					<Col span={6} className='ContainerCardFileUpload'>
						<CardFileUpload
							nameFile={"Plantilla Sell Out"}
							onAction={(fileUrl) => {
								uploadSellOut.mutate(fileUrl)
							}}
							nameFileTemplate="Sell Out"
							onDownloadTemplates={(name) => {
								downloadTemplates.mutate(name)
							}}
							isLoading={uploadSellOut.isPending}
							isSuccess={uploadSellOut.isSuccess}
							isError={uploadSellOut.isError}
						/>
					</Col>
					{/* <Col span={6} className='ContainerCardFileUpload'>
						<CardFileUpload
							nameFile={"Master Pricing"}
							onAction={(fileUrl) => {
								uploadPricingMaster.mutate(fileUrl)
							}}
							isLoading={uploadPricingMaster.isPending}
							isSuccess={uploadPricingMaster.isSuccess}
						/>
					</Col> */}
					{/* <Col span={6} className='ContainerCardFileUpload'>
						<CardFileUpload
							nameFile={"Sell In"}
							onAction={(fileUrl) => {
								cargaMasterSellIn.mutate(fileUrl)
							}}
							isLoading={cargaMasterSellIn.isPending}
							isSuccess={cargaMasterSellIn.isSuccess}
						/>
					</Col> */}
					{/* <Col span={6} className='ContainerCardFileUpload'>
						<CardFileUpload
							nameFile={"Master Data Products"}
							onAction={(fileUrl) => {
								uploadProductMaster.mutate(fileUrl)
							}}
							isLoading={uploadProductMaster.isPending}
							isSuccess={uploadProductMaster.isSuccess}
						/>
					</Col> */}
					<Col span={6} className='ContainerCardFileUpload'>
						<CardFileUpload
							nameFile={"MD materiales"}
							onAction={(fileUrl) => {
								uploadProductMaster.mutate(fileUrl)
							}}
							nameFileTemplate="MD Materiales"
							onDownloadTemplates={(name) => {
								downloadTemplates.mutate(name)
							}}
							isLoading={uploadProductMaster.isPending}
							isSuccess={uploadProductMaster.isSuccess}
							isError={uploadProductMaster.isError}
						/>
					</Col>
					<Col span={6} className='ContainerCardFileUpload'>
						<CardFileUpload
							nameFile={"MD clientes"}
							onAction={(fileUrl) => {
								uploadClientMaster.mutate(fileUrl)
							}}
							nameFileTemplate="MD Clientes"
							onDownloadTemplates={(name) => {
								downloadTemplates.mutate(name)
							}}
							isLoading={uploadClientMaster.isPending}
							isSuccess={uploadClientMaster.isSuccess}
							isError={uploadClientMaster.isError}
						/>
					</Col>
					<Col span={6} className='ContainerCardFileUpload'>
						<CardFileUpload
							nameFile={"MD tipo de cambio"}
							onAction={(fileUrl) => {
								uploadExChangeRate.mutate(fileUrl)
							}}
							nameFileTemplate="MD tipo de cambio"
							onDownloadTemplates={(name) => {
								downloadTemplates.mutate(name)
							}}
							isLoading={uploadExChangeRate.isPending}
							isSuccess={uploadExChangeRate.isSuccess}
							isError={uploadExChangeRate.isError}
						/>
					</Col>
				</Row>
			</Col>
			<Col span={6}>
				<CardNotification />
			</Col>
		</Row>
	)
}

export default FileUpload